import DealerSearch from "./dealer/DealerSearch";

if ($('#searchLocationContainer').length) {
    const dealerSearch = new DealerSearch();
}
